module.exports = __webpack_public_path__ + "img/logo.b2a4d61b.jpg";